import { useEffect } from 'react'
import '../DocumentPage.css'

const InitialConfiguration = () => {
  useEffect(() => {
    const headings = document.querySelectorAll('.doc-content h2, .doc-content h3')
    headings.forEach((heading) => {
      if (!heading.id) {
        heading.id = heading.textContent.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '')
      }
    })
  }, [])

  return (
    <div className="doc-page">
      <div className="doc-content">
        <h1>Initial Configuration</h1>
        <p className="lead">
          Learn how to create and configure your first CSV data table with the Variable Modding System.
        </p>

        <h2>Creating Your First CSV Configuration</h2>
        <p>To create a new CSV configuration:</p>
        <ol>
          <li>Right-click in the Content Browser</li>
          <li>Select <strong>Miscellaneous → Data Table</strong></li>
          <li>Choose your row structure</li>
          <li>Name your data table</li>
        </ol>

        <h2>Basic Settings</h2>
        <p>Configure the following basic settings for your variable system:</p>
        <ul>
          <li><strong>Variable Names</strong>: Define clear, descriptive names</li>
          <li><strong>Data Types</strong>: Choose appropriate data types for each variable</li>
          <li><strong>Default Values</strong>: Set sensible defaults</li>
        </ul>

        <h2>Best Practices</h2>
        <ul>
          <li>Use consistent naming conventions</li>
          <li>Document your variables with comments</li>
          <li>Organize related variables together</li>
          <li>Test configurations before deployment</li>
        </ul>

        <h2>Next Steps</h2>
        <p>Once configured, move on to testing in the editor.</p>
      </div>
    </div>
  )
}

export default InitialConfiguration
